import { render, staticRenderFns } from "./AllergenLegende.vue?vue&type=template&id=70e937d4&scoped=true"
import script from "./AllergenLegende.vue?vue&type=script&lang=js"
export * from "./AllergenLegende.vue?vue&type=script&lang=js"
import style0 from "./AllergenLegende.vue?vue&type=style&index=0&id=70e937d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e937d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70e937d4')) {
      api.createRecord('70e937d4', component.options)
    } else {
      api.reload('70e937d4', component.options)
    }
    module.hot.accept("./AllergenLegende.vue?vue&type=template&id=70e937d4&scoped=true", function () {
      api.rerender('70e937d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AllergenLegende.vue"
export default component.exports